(() => {
  function init(root) {
    root.querySelectorAll('slider-component').forEach(component => {
      const list = component.querySelector('.multicolumn-list.slider--mobile');
      if (!list || !list.querySelector('.testimonial-card') || list.dataset.fitTestimonial) return;
      list.dataset.fitTestimonial = 'true';
      const slides = Array.from(list.children).filter(item => item.querySelector('.testimonial-card'));
      let frame;
      function fit() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (!window.matchMedia('(max-width: 749px)').matches) {
            list.style.removeProperty('height');
            return;
          }
          const left = list.getBoundingClientRect().left;
          const active = slides.reduce((best, slide) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(best.getBoundingClientRect().left - left) ? slide : best, slides[0]);
          if (!active) return;
          const card = active.querySelector('.testimonial-card');
          const height = Math.ceil(card.getBoundingClientRect().height + 4);
          if (height > 4) list.style.height = height + 'px';
        });
      }
      slides.forEach(slide => {
        const card = slide.querySelector('.testimonial-card');
        const observer = new ResizeObserver(fit);
        observer.observe(card);
      });
      list.addEventListener('scroll', fit, { passive: true });
      window.addEventListener('resize', fit, { passive: true });
      fit();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
